import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import { RichTextBlocks } from '~/components/Abstracts/RichText'
import BlogNavigation, {
  BlogNavigationProps,
} from '~/components/Navigation/BlogNavigation'
import ArticleCard, { ArticleCardProps } from '~/components/Slices/ArticleCard'
import useLoadMoreArticlesList from '~/components/Slices/BlogGrid/hooks/useLoadMoreArticlesList'
import Pagination, { PaginationProps } from '~/components/UI/Pagination'
import SquaredCta from '~/components/UI/SquaredCta'

import { useStyle } from '~/providers/StyleProvider'

import { BLOG } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface BlogGridProps {
  className?: string
  pagination?: PaginationProps
  navigation?: BlogNavigationProps
  title?: RichTextBlocks
  previewRef?: string
  items: ArticleCardProps[]
}

function BlogGrid({
  className,
  navigation,
  items,
  pagination,
  previewRef,
}: BlogGridProps) {
  const t = useTranslate()

  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const { articles, count, loadMore, hasLoadMore, isLoading, isFetching } =
    useLoadMoreArticlesList({
      articles: items,
      categories: navigation?.categories,
      maxPage: pagination?.maxPage,
      previewRef,
    })

  return (
    <div className={cx(css.BlogGrid, className)}>
      <BlogNavigation {...navigation} count={count} isLoading={isFetching} />
      <div className={cx(gridStyle)}>
        <div className={css.articlesWrapper}>
          {articles.map((article, index) => {
            return (
              <ArticleCard
                key={`blog-article-${index}`}
                {...article}
                className={css.article}
                namePreset={GlobalTextPreset.Title16Haffer}
              />
            )
          })}
        </div>
      </div>
      <Pagination {...pagination} hidden />

      {hasLoadMore && (
        <div className={cx(css.footer)}>
          <SquaredCta
            className={cx(css.loadMoreButton)}
            onClick={loadMore}
            disabled={isLoading}
            isLoading={isFetching}>
            {t(BLOG.LOAD_MORE)}
          </SquaredCta>
        </div>
      )}
    </div>
  )
}

BlogGrid.defaultProps = {}

export default BlogGrid
